import React from 'react';
import { Container } from 'react-bootstrap';
import './callLog.scss';
import { Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Chart from 'react-apexcharts'
import { ZLoader } from '../../../shared/loader/ZLoader'
const ReportMarkup = (props) => {
     const { isLoading, callLogSeries, callLogOptions } = props
     return (
          <div className="call-log-container">

               {isLoading ? <ZLoader /> : null}
               {callLogSeries.length && callLogOptions.length ?
                    <div id="chart">
                         <Chart options={{
                              chart: {
                                   height: 350,
                                   type: 'bar',
                                   events: {
                                        click: function (chart, w, e) {
                                        }
                                   }
                              },
                              // colors: colors,
                              plotOptions: {
                                   bar: {
                                        columnWidth: '45%',
                                        distributed: true
                                   }
                              },
                              title: {
                                   text: 'Call Logs',
                                   align: 'left'
                              },
                              dataLabels: {
                                   enabled: false
                              },
                              legend: {
                                   show: false
                              },
                              xaxis: {
                                   categories: callLogOptions,
                                   labels: {
                                        style: {
                                             // colors: colors,
                                             fontSize: '12px'
                                        }
                                   }
                              }
                         }} series={[{
                              data: callLogSeries
                            }]} type="bar" height={350} />
                    </div>
                    : 
                    <>
                    <p style={{fontWeight:'500'}}>Call Logs</p>
                    <h4>No data available</h4>
                    </>
                    }
          </div>
     )
}

export default ReportMarkup;